import { Line3 as t } from "three";
import { V3toVector3 as o } from "./index9.js";
function m(r) {
  return Array.isArray(r) ? new t(o(r[0]), o(r[1])) : r;
}
export {
  m as LineV3toLine3
};
//# sourceMappingURL=index2.js.map
